import { render, staticRenderFns } from "./AllNCF.vue?vue&type=template&id=3b8f6884&scoped=true&"
import script from "./AllNCF.vue?vue&type=script&lang=js&"
export * from "./AllNCF.vue?vue&type=script&lang=js&"
import style0 from "./AllNCF.vue?vue&type=style&index=0&id=3b8f6884&prod&lang=scss&scoped=true&"
import style1 from "./AllNCF.vue?vue&type=style&index=1&id=3b8f6884&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f6884",
  null
  
)

export default component.exports